/** @jsx jsx */
import { Button, jsx } from 'theme-ui'
import VisuallyHidden from '~/components/Generic/VisuallyHidden'

const QuantityIncrementorButton = ({ children, disabled, label, onClick }) => (
  <Button
    variant="reset"
    onClick={() => onClick()}
    disabled={disabled}
    sx={{
      alignItems: 'center',
      backgroundColor: 'greyLight',
      color: !disabled ? 'greyDark' : 'greyMedium',
      display: 'flex',
      height: ['32px', '40px'],
      justifyContent: 'center',
      width: ['32px', '40px'],
    }}
  >
    {children}
    <VisuallyHidden as="span">{label}</VisuallyHidden>
  </Button>
)

export default QuantityIncrementorButton
